import { NgModule } from "@angular/core";
import { SectionComponent } from "@/shared/components/section/section.component";
import { SpinnerModule } from "@/shared/components/spinner/spinner.module";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [SectionComponent],
  exports: [SectionComponent],
  imports: [
    SpinnerModule,
    CommonModule,
  ],
})

export class SectionModule {}
